module.exports = __webpack_public_path__ + "static/media/6.a51b7965.png";